// src/components/UserTournamentRanks.js
// Seznam turnajů, kterých se uživatel účastnil, s jeho pozicí v globálním žebříčku.
// Používá se na stránce Profil a v záložce Statistiky v modálu tipů uživatele.
import React, { useEffect, useState } from 'react';
import leaderboardService from '../services/leaderboardService';
import { useTranslation } from 'react-i18next';
import '../styles/UserTournamentRanks.css';

const MEDALS = { 1: '🥇', 2: '🥈', 3: '🥉' };
const SPORT_ICONS = { FOOTBALL: '⚽', HOCKEY: '🏒' };

const UserTournamentRanks = ({ userId }) => {
	const { t } = useTranslation();
	const [ranks, setRanks] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (!userId) return undefined;
		let cancelled = false;
		setLoading(true);
		leaderboardService.getUserTournamentRanks(userId)
			.then((data) => { if (!cancelled) setRanks(data || []); })
			.catch((err) => {
				console.error('Chyba při načítání turnajových umístění:', err);
				if (!cancelled) setRanks([]);
			})
			.finally(() => { if (!cancelled) setLoading(false); });
		return () => { cancelled = true; };
	}, [userId]);

	if (loading) {
		return (
			<div className="utr-loading">
				<span className="utr-spinner" />
			</div>
		);
	}

	if (!ranks || ranks.length === 0) {
		return (
			<p className="utr-empty">
				{t('tournamentRanks.empty', { defaultValue: 'Zatím žádná účast v turnaji' })}
			</p>
		);
	}

	return (
		<ul className="utr-list">
			{ranks.map((r) => (
				<li key={r.tournamentId} className="utr-row">
					<span className="utr-sport" aria-hidden="true">
						{SPORT_ICONS[r.sportType] || '🏆'}
					</span>
					<div className="utr-info">
						<span className="utr-name" title={r.tournamentName}>
							{t(`tournaments.${r.tournamentName}`, {
								year: r.tournamentYear,
								defaultValue: r.tournamentName,
							})}
						</span>
						<span className="utr-meta">
							{t(`tournamentRanks.status.${r.tournamentStatus}`, { defaultValue: '' })}
							{' · '}
							{t('tournamentRanks.points', { count: r.points, defaultValue: '{{count}} bodů' })}
						</span>
					</div>
					<div className="utr-rank">
						<span className={`utr-rank-value ${r.rank <= 3 ? 'is-top' : ''}`}>
							{MEDALS[r.rank] ? <span className="utr-medal">{MEDALS[r.rank]}</span> : null}
							{t('tournamentRanks.rank', { rank: r.rank, defaultValue: '{{rank}}.' })}
						</span>
						<span className="utr-rank-total">
							{t('tournamentRanks.outOf', { total: r.totalParticipants, defaultValue: 'z {{total}} hráčů' })}
						</span>
					</div>
				</li>
			))}
		</ul>
	);
};

export default UserTournamentRanks;
